var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"elevation-0 custom-btn",class:_vm.isSecondary && 'custom-btn-secondary',attrs:{"color":_vm.isSecondary ? 'grey lighten-2' : 'blue',"disabled":_vm.isDisabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('onClick')}}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d32d890","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/utils/buttons/CustomButton.vue
// module id = null
// module chunks = 